module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_44-97b40dcaa259394da8de52b4e1a71a0d.png";